import { AxiosError } from "axios";

export const ASSETS_ROUTES = {
    IMGS: {
        logo: "/images/global/WWG-Logo-Transparent.png",
        techAvatarUrl: "/images/techs/Default-Avatar.JPG",
        labAvatarUrl: "/images/global/default_dl_logo.png",
        incognitoTechUrl: "/images/techs/Incognito.png",
        logo_slogan: "/images/global/WWG-Logo-Tagline-TRANSPARENT.png",
    },
};

//pagination size has to be the same as offset from backend query.
export const TECH_SEARCH_PAGINATION_SIZE = 12;
export const LAB_SEARCH_PAGINATION_SIZE = 10;
export const GENERAL_PAGINATION_SIZE = 10;

export const ERROR_API_FRAUD = "Spam / Advertising alert!";

export const ERROR_IS_FRAUD = (error: any) => {
    const fraudError = (error as AxiosError<{ error: string }>).response?.data;
    if (fraudError && fraudError.error === ERROR_API_FRAUD) return true;
    return false;
};

export const GALLERY_LIMIT = 6;
export const HOBBIES_LIMIT = 10;
export const MEDIUM_TEXT_INPUT_MAX_CHARACTERS = 250;
export const LARGE_TEXT_INPUT_MAX_CHARACTERS = 500;

export const SUPPORT_EMAIL = "help@winwingo.com";

export const DEVICES_SIZES_IN_PX = {
    small: 768,
    medium: 991,
};

export const LAB_PRICE = 299;
export const TECH_PRICE = 0;

// validate password with min length
export const MIN_PASSWORD_LENGTH = 6;
